import { gql, useQuery } from "@apollo/client";
import useCapabilities, { useCanViewTasksBool } from "@/hooks/useCapabilities";

const OPEN_TASK_COUNT_QUERY = gql`
  query OpenTaskCount($input: BackofficeCRMTasksInput) {
    tasks(first: 0, input: $input) {
      totalCount
    }
  }
`;

interface OpenTaskCountResponse {
  tasks: {
    totalCount: number;
  };
}

export default function useOpenTaskCount(): number | null {
  const { id: currentUserId } = useCapabilities();
  const canViewTasks = useCanViewTasksBool();

  const { data } = useQuery<OpenTaskCountResponse>(OPEN_TASK_COUNT_QUERY, {
    variables: {
      input: {
        assignedToId: currentUserId,
        stage: ["OPEN"]
      }
    },
    skip: !currentUserId || !canViewTasks,
    fetchPolicy: "cache-and-network"
  });

  return data?.tasks?.totalCount ?? null;
}
